import { BILLING_PATH } from '@app/constants/navigation';

import {
  MCP_AUTHORIZATION_CODE_PATTERN,
  MCP_AUTHORIZATION_STATE_PATTERN,
  MCP_NAVIGATE_MESSAGE,
  MCP_OAUTH_COMPLETE_MESSAGE,
  MCP_READY_MESSAGE,
  MCP_UUID_PATTERN,
} from '../constants';

interface McpReadyMessage {
  type: typeof MCP_READY_MESSAGE;
  nonce: string;
}

interface McpNavigateMessage {
  type: typeof MCP_NAVIGATE_MESSAGE;
  path: typeof BILLING_PATH;
}

interface McpOAuthCompleteMessage {
  type: typeof MCP_OAUTH_COMPLETE_MESSAGE;
  code: string;
  state: string;
}

const isMessageRecord = (data: unknown): data is Record<string, unknown> =>
  typeof data === 'object' && data !== null;

export const isMcpReadyMessage = (data: unknown): data is McpReadyMessage =>
  isMessageRecord(data) &&
  data.type === MCP_READY_MESSAGE &&
  typeof data.nonce === 'string' &&
  MCP_UUID_PATTERN.test(data.nonce);

// Сервис просит CRM открыть только страницу оплаты; другой адрес не выполняется.
export const isMcpNavigateMessage = (
  data: unknown
): data is McpNavigateMessage =>
  isMessageRecord(data) &&
  data.type === MCP_NAVIGATE_MESSAGE &&
  data.path === BILLING_PATH;

export const isMcpOAuthCompleteMessage = (
  data: unknown
): data is McpOAuthCompleteMessage =>
  isMessageRecord(data) &&
  data.type === MCP_OAUTH_COMPLETE_MESSAGE &&
  typeof data.code === 'string' &&
  MCP_AUTHORIZATION_CODE_PATTERN.test(data.code) &&
  typeof data.state === 'string' &&
  MCP_AUTHORIZATION_STATE_PATTERN.test(data.state);
